module.exports = __webpack_public_path__ + "assets/EU-council-a551b2afe7aa7140dcb454f99e94b9ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/EU-council.jpg
// module id = 504
// module chunks = 1